import { mapState } from 'pinia'

import {
  filterNavigation,
  getBookmarkEntries,
  getListEntries,
} from 'src/components/navigation/filter.js'
import { TIMELINES } from 'src/components/navigation/navigation.js'
import NavigationEntry from 'src/components/navigation/navigation_entry.vue'
import NavigationEntryList from 'src/components/navigation/navigation_entry_list.vue'
import Popover from 'src/components/popover/popover.vue'

import { useBookmarkFoldersStore } from 'src/stores/bookmark_folders'
import { useInstanceCapabilitiesStore } from 'src/stores/instance_capabilities.js'
import { useInterfaceStore } from 'src/stores/interface'
import { useListsStore } from 'src/stores/lists'
import { useUsersStore } from 'src/stores/users.js'

// Route -> i18n key mapping, exported and not in the computed
// because nav panel benefits from the same information.
export const timelineNames = (supportsBookmarkFolders) => {
  return {
    friends: 'nav.home_timeline',
    bookmarks: supportsBookmarkFolders ? 'nav.all_bookmarks' : 'nav.bookmarks',
    dms: 'nav.dms',
    'public-timeline': 'nav.public_tl',
    'public-external-timeline': 'nav.twkn',
    quotes: 'nav.quotes',
    bubble: 'nav.bubble',
  }
}

const TimelineMenu = {
  components: {
    Popover,
    NavigationEntry,
    NavigationEntryList,
  },
  data() {
    return {
      isOpen: false,
    }
  },
  created() {
    if (timelineNames(this.bookmarkFolders)[this.$route.name]) {
      useInterfaceStore().setLastTimeline(this.$route.name)
    }
  },
  computed: {
    listEntries() {
      return getListEntries(useListsStore())
    },
    bookmarkEntries() {
      return getBookmarkEntries(useBookmarkFoldersStore())
    },
    useListsMenu() {
      const route = this.$route.name
      return route === 'lists-timeline'
    },
    useBookmarkFoldersMenu() {
      const route = this.$route.name
      return (
        this.bookmarkFolders &&
        (route === 'bookmark-folder' || route === 'bookmarks')
      )
    },
    timelineName() {
      const route = this.$route.name
      if (route === 'instance-timeline') {
        return this.$t('nav.instance_timeline', {
          instance: this.$route.params.instance,
        })
      }
      if (route === 'tag-timeline') {
        return '#' + this.$route.params.id
      }
      if (route === 'lists-timeline') {
        return useListsStore().findListTitle(this.$route.params.id)
      }
      if (route === 'bookmark-folder') {
        return useBookmarkFoldersStore().findBookmarkFolderName(
          this.$route.params.id,
        )
      }
      const i18nkey = timelineNames(this.bookmarkFolders)[this.$route.name]
      return i18nkey ? this.$t(i18nkey) : route
    },
    ...mapState(useInstanceCapabilitiesStore, ['bookmarkFolders']),
    ...mapState(useUsersStore, ['currentUser']),
    timelinesList() {
      return filterNavigation(
        Object.entries(TIMELINES).map(([k, v]) => ({ ...v, name: k })),
      )
    },
  },
  methods: {
    openMenu() {
      // $nextTick is too fast, animation won't play back but
      // instead starts in fully open position. Low values
      // like 1-5 work on fast machines but not on mobile, 25
      // seems like a good compromise that plays without significant
      // added lag.
      setTimeout(() => {
        this.isOpen = true
      }, 25)
    },
    blockOpen(event) {
      // For the blank area inside the button element.
      // Just setting @click.stop="" makes unintuitive behavior when
      // menu is open and clicking on the blank area doesn't close it.
      if (!this.isOpen) {
        event.stopPropagation()
      }
    },
  },
}

export default TimelineMenu
